import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=2074a6d8&scoped=true&"
import script from "./invoice-list.vue?vue&type=script&lang=js&"
export * from "./invoice-list.vue?vue&type=script&lang=js&"
import style0 from "./invoice-list.vue?vue&type=style&index=0&id=2074a6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074a6d8",
  null
  
)

export default component.exports